import React, { useContext } from "react";
import "./tours.css";
import { NavLink } from "react-router-dom";
import { WiTime4 } from "react-icons/wi";
import { TbHome } from "react-icons/tb";
import { RiShoppingBag4Line } from "react-icons/ri";
import { GoArrowSwitch, GoArrowRight } from "react-icons/go";
import { CiCalendar } from "react-icons/ci";
import { LanguageContext } from "../settings/LanguageContext";

import tour1 from "../photos/Garnitemple.png";
import tour2 from "../photos/tsaxkadzorropeway.png";
import tour3 from "../photos/kecharis.png";
import tour4 from "../photos/sevanlich.png";
import tour5 from "../photos/tsaxrop2.png";
import tour6 from "../photos/khorvirap.png";
import tour7 from "../photos/noravank.png";
import tour8 from "../photos/ej1.jpeg"
import Kh1 from "../photos/Kh1.jpg"
import svdlpz from "../photos/svdlpz.jpg"
import ksat from "../photos/ksat.jpg"
import asm2 from "../photos/asm2.jpg"
import asam2 from "../photos/asam2.jpg"
import stc3 from "../photos/stc3.jpg"


export  const booktour = [
  { id: "garni", place: "Garni Geghard Symphony Of Stones", description: "This unforgettable journey explores some of Armenia’s most treasured landmarks...", hours: "6-7 hours", price: "70 USD", photo: tour1 },
  { id: "tsaghakadzorsevan", place: "Tsaghkadzor Sevan", description: "Experience the beauty and history of Armenia’s highlands on this scenic tour.", hours: "7-8 hours", price: "100 USD", photo: tour2 },
  { id: "tsaxkadzorgarni", place: "Garni Geghard Tsaghkadzor", description: "Begin your day with a journey through some of Armenia’s most remarkable landmarks.", hours: "8-9 hours", price: "120 USD", photo: tour3 },
  { id: "garnisevan", place: "Garni Geghard Sevan", description: "This enriching day tour covers Armenia’s most iconic landmarks, including Charen...", hours: "8-9 hours", price: "120 USD", photo: tour4 },
  { id: "tsaghsevandilijan", place: "Tsaghkadzor Sevan Dilijan", description: "Experience the highlights of Armenia in a single day. Soar above Tsaghkadzor on...", hours: "8-9 hours", price: "120 USD", photo: tour5 },
  { id: "khorvirapnoravank", place: "Khor Virap Areni Noravank", description: "Embark on a captivating journey through Armenia’s history, culture, and stunning...", hours: "8-9 hours", price: "120 USD", photo: tour6 },
  { id: "khorvirapnoravankjermuk", place: "Khor Virap Areni Noravank Jermuk ", description: "Experience the best of Armenia’s history, culture, and natural beauty on this full...", hours: "8-9 hours", price: "120 USD", photo: tour7 },
  { id: "HripsimeMonasteryZvartnotsCathedral", place: "Hripsime Monastery Mother Cathedral Zvartnots Cathedral", description: "Explore Armenia’s spiritual and cultural heart in a journey through history...", hours: "4-5 hours", price: "160 USD", photo: tour8 },
  { id: "garnigeghardkhorvirap", place: "Garni Temple Symphony of Stone Geghard Khor Virap", description: "Discover the heart of Armenia’s heritage and its breathtaking landscapes...", hours: "4-5 hours", price: "160 USD", photo: Kh1 },
  { id: "sevandilijan", place: "Sevan Dilijan old town Haghartsin Lake Parz Tour", description: "Discover the beauty of Lake Sevan and visit the historic Sevanavank Monastery...", hours: "8-9 hours", price: "130 USD", photo: svdlpz },
  { id: "khorviraptatevmonastery", place: "Khor Virap Areni Shaki Tatev Tour", description: "Discover the beauty of southern Armenia on a journey through history and nature.", hours: "4-6 hours", price: "200 USD", photo: ksat },
  // { id: "sevandilijan", place: "Sevan Dilijan old town Haghartsin Lake Parz Tour", description: "Discover the beauty of Lake Sevan and visit the historic Sevanavank", hours: "8-9 hours", price: "130 USD", photo: Kh1 },
  { id: "alphabetmonumentmylermountainresort", place: "Alphabet Monument Saghmosavank Myler Mountain Resort  Tour", description: "Experience Armenia’s rich culture and stunning landscapes.", hours: "5-6 hours", price: "120 USD", photo: asm2 },
  { id: "alphabetmonumentamberdaragats", place: "Alphabet Monument Saghmosavank Amberd Fortress & Mount Aragats  Tour", description: "Discover Armenia’s heritage and natural beauty in one journey.", hours: "5-6 hours", price: "120 USD", photo: asam2 },
  { id: "shakiwaterfalltatevkhndzoresk", place: "Shaki Waterfall Tatev  Khndzoresk Cave Village Tour ", description: "Discover the natural beauty and historic wonders of southern Armenia.", hours: "11-12 hours", price: "200 USD", photo:  stc3 },


];

const Tours = () => {
  const { lang } = useContext(LanguageContext);

  // Translation text
  const t = {
    title: lang === "EN" ? "Make memories, not just trips." : "Создавай воспоминания, а не просто поездки.",
    groupTours: lang === "EN" ? "Group Tours" : "Групповые туры",
    tourPackages: lang === "EN" ? "Tour Packages" : "Турпакеты",
    armeniaGeorgia: lang === "EN" ? "Armenia + Georgia" : "Армения + Грузия",
    privateTours: lang === "EN" ? "Private Tours" : "Частные туры",
    more: lang === "EN" ? "More" : "Подробнее",
    privatetit: lang === "EN" ? "Private Tours" : "Частные туры",
    privatdiscover: lang === "EN"
      ? "Discover your destination your way with flexible, private tours made just for you."
      : "Откройте своё направление по-своему с гибкими частными турами, созданными специально для вас",
    partner: lang === "EN" ? "Our Partner Hotels" : "Наши партнёрские отели",
    selecttour: lang === "EN" ? "A selection of trusted hotels chosen to ensure a comfortable and enjoyable stay." : "Подборка проверенных отелей, выбранных для обеспечения комфортного и приятного пребывания.",
  };

  return (
    <div className="main-tour">
      <div className="tour-bk-pic">
        <h3 className="cascade-text">{t.title}</h3>
      </div>

      <div className="discover-bottom-buttuns">
        <div className="discover-bottom-btn" id="prtureyelic"><CiCalendar size={24} color="#000" /> {t.privateTours}</div>
        <div className="discover-bottom-btn"><TbHome size={24} color="#2176FF" /> {t.groupTours}</div>
        <div className="discover-bottom-btn"><RiShoppingBag4Line size={24} color="#2176FF" /> {t.tourPackages}</div>
        <div className="discover-bottom-btn" id="tours-btn-color1"><GoArrowSwitch size={24} color="#2176FF" /> {t.armeniaGeorgia}</div>
      </div>

      <div className="privateturs-turs-container-ttle">
        <h2 className="privateturs-turs">{t.privatetit}</h2>
        <p className="privateturs-turs-p">{t.privatdiscover}</p>
      </div>

      <div className="tour-container">
        {booktour.map((tour) => {
          const card = (
            <div className="tour-point">
                <div className="tour-point-imgsa">
              <img src={tour.photo} alt={tour.place} />
              </div>
              <div className="tour-tex-book">
                <h2 className="tour-package-title">{tour.place}</h2>
                <p className="tour-package-text">{tour.description}</p>
                <div className="tour-time-price">
                  <WiTime4 /> {tour.hours} <span>{tour.price}</span>
                </div>
                <div className="book-tour-now">
                  {t.more}
                  <div className="arrow-tour-btn">
                    <GoArrowRight className="arrow-tour-icon" />
                  </div>
                </div>
              </div>
            </div>
          );

          // Dynamic NavLink based on tour.id
          return (
            <NavLink
              key={tour.id}
              to={`/tour/${tour.id}`}
              className="tour-card-link"
            >
              {card}
            </NavLink>
          );
        })}
      </div>

      <div className="private-partners">
        <h2>{t.partner}</h2>
        <p>{t.selecttour}</p>
      </div>

      <div className="tour-buttons">
        <button className="tour-button-page">1</button>
        <button className="tour-button-page">2</button>
        <button className="tour-button-page">3</button>
      </div>
    </div>
  );
};

export default Tours;
